import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowRightIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileArrowRightIn"><Path d="M19.5 13.5V9L13 2.5H4.5V21.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="round"/><Path d="M13.5 19.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 16.5L12.5 19.5L15.5 22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFileArrowRightIn;
